import { connect } from 'react-redux'
import { compose } from 'recompose'
import { dataFetched, makesQueries } from 'data/graphql'

import { getMeQuery } from 'remote/users'

export const providesUserDataRefresher = compose(
  connect(
    null,
    {
      dataFetched,
    }
  ),
  makesQueries({
    query: getMeQuery,
    queryOnMount: false,
    queryOnChanges: false,
    resyncPolicy: 'refetch',
    getOnResultFromProps: ({ dataFetched }) => ({ result }) => {
      const { me, getUsersNotifications, showUserPreferences } = result.data
      dataFetched([me, getUsersNotifications, showUserPreferences])
    },
  })
)
